import { Component, OnInit, Input } from '@angular/core';
import { NgStyle } from '@angular/common';
import { CdsIconConfig } from '@cds/ng-core/icon';
import { FormIcons } from '@cds/ng-themes';
import { CdsIconModule } from '@cds/ng-web-components/icon';
import { CdsLanguageModule } from '@cds/ng-core/lang';
@Component({
  selector: 'app-no-result-found',
  templateUrl: './no-result-found.component.html',
  styleUrls: ['./no-result-found.component.scss'],
  imports: [CdsIconModule, CdsLanguageModule, NgStyle],
})
export class NoResultFoundComponent implements OnInit {
  @Input() msg?: string;
  constructor() {}

  ngOnInit(): void {}

  noResultFoundIcon = FormIcons.search;

  iconConfig: CdsIconConfig = { size: 'md' };
}
